const routesPaths = {
  companies: '/',
  company: '/company',
  companyEdit: '/:companyId/edit/',
  companyNew: '/new',
};

export default routesPaths;
